/*
 /*
 * Filename: d:\projects\AutoFiFront\src\Theme\ButtonAlt.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Tuesday, February 14th 2023, 2:04:37 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const ButtonAlt = styled.button.attrs((props: any) => ({
    bgColor: props.bgColor,
    borderRadius: props.borderRadius,
    minWidth: props.minWidth,
    maxWidth: props.maxWidth,
}))`
position: relative;
cursor: pointer;
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
gap: 0.5rem;
min-width: ${props => props.minWidth};
max-width: ${props => props.maxWidth};
height: 3.5rem;
font-weight: bold;
background: none;
border-radius: 0.5rem;
transform: translateY(calc(var(--y, 0) * 1%)) scale(var(--scale));
transition: transform 0.1s;
color: ${(props: any) => getThemeColor(props.bgColor)};
border: solid 3px ${(props: any) => getThemeColor(props.bgColor)};
&:hover {
    --y: -10;
    --scale: 1.1;
    --border-scale: 1, 0.9;
    background-color: ${(props: any) => getThemeColor(props.bgColor)};
    color: var(--text-color-second);
    outline: none;
}
&:active{
    --y: 5%;
    --scale: 0.9;
    --border-scale: 0.95, 0.75;
}
&:before{
    content: "";
    position: absolute;
    inset: calc(1rem * -1);
    border: solid 0.5rem ${(props: any) => getThemeColor(props.bgColor)};
    border-radius: 0.5rem;
    transform: scale(var(--border-scale, 0));
    transition: transform 0.125s;
    --angle-one: 105deg;
    --angle-two: 290deg;
    --spread-one: 30deg;
    --spread-two: 40deg;
    --start-one: calc(var(--angle-one) - (var(--spread-one) * 0.5));
    --start-two: calc(var(--angle-two) - (var(--spread-two) * 0.5));
    --end-one: calc(var(--angle-one) + (var(--spread-one) * 0.5));
    --end-two: calc(var(--angle-two) + (var(--spread-two) * 0.5));
    mask: conic-gradient(
        transparent 0 var(--start-one),
        white var(--start-one) var(--end-one),
        transparent var(--end-one) var(--start-two),
        white var(--start-two) var(--end-two),
        transparent var(--end-two)
        );
        z-index: -1;
    }
@media (width < 1080px){
    width: 100%;
    border-radius: ${props => props.borderRadius};
}
@media (width <768px){
    color: white;
    background-color: ${(props: any) => getThemeColor(props.bgColor)};
}
`;

export default ButtonAlt;
